import * as React from 'react'

import { League } from '../../../../sdk/model';
import { leagueApi } from '../../../../adapters/APIExporter';
import ManageUserGroup from '../../../util/ManageUserGroup';

interface editCommissionersProps {
  league: League,
  callback: Function
}

function EditCommissioners(props: editCommissionersProps) {
  function submitChanges(updatedCommissioners) {
    const newLeague = {...props.league};
    newLeague.commissioners = updatedCommissioners;
    leagueApi.updateLeague(props.league.id!, newLeague).then(props.callback);
  }
  
  return <ManageUserGroup title="Commissioner(s)" initialUsers={props.league.commissioners!} omittedUsers={[]} submitChanges={submitChanges} autosubmit={false} />
}

export default EditCommissioners;
